import { Injectable } from "@nestjs/common";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { BankDetailsEntity } from "./bank-details-entity";
import { BankDetailsResponseModel, BankDetailsRequest, CommonResponse, CompanyReq, BankIdReq } from "@gtpl/shared-models/masters";

@Injectable()

export class BankDetailsService{
    [x: string]: any;
    constructor(
        @InjectRepository(BankDetailsEntity) private repo: Repository<BankDetailsEntity>,

    ){}
  
    async getAllBankDetailsInfo(): Promise<BankDetailsResponseModel> {
        try {
            let res = []
            const info = await this.repo.find()
            if (info.length>0) {
                for(const data of info ){
                    console.log(data,'getalllllllllllllllllllllllll');
                    res.push(new BankDetailsRequest(data.id,data.bankName,data.bankAccount,data.swiftCode,data.ifscCode,data.branchName,data.bankAddress,data.company,data.createdUser,data.updatedUser,data.isActive,data.versionFlag,data.createdAt))
                }
                console.log(res,'pppppppppp');
                
                return new BankDetailsResponseModel(true, 1,'Data retrieved',res)
            } else {
                return new BankDetailsResponseModel(false, 0,'No data found')
            }
        } catch (err) {
            return new BankDetailsResponseModel(false, 0, 'Something went wrong', err)
        }
    }
    async getDuplicateAcc(comp: string): Promise<BankDetailsEntity> {
        //  console.log(employeeId);
            const response = await this.repo.findOne({
            where: {bankAccount: comp},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }
        async createBankDetails(dto: BankDetailsRequest, isUpdate: boolean): Promise<BankDetailsResponseModel> {
            console.log(dto,'serviceeeeeeeeeeeeeee');
            
            try {
                let res=[]
                if (!isUpdate) {
                    const existing = await this.repo.findOne({ where: { bankAccount: dto.bankAcc } });
                    if (existing) {
                        throw new Error('Account Number already exists');
                    }
                }
                const entityData = new BankDetailsEntity();
                entityData.bankAccount = dto.bankAcc
                entityData.bankAddress = dto.bankAddress
                entityData.isActive = dto.isActive
                entityData.bankName = dto.bankName
                entityData.branchName = dto.branchName
                entityData.ifscCode = dto.ifscCode
                entityData.swiftCode = dto.swiftCode
                entityData.company = dto.company
                if (isUpdate) {
                    const existingData = await this.repo.findOne(dto.id);
                    entityData.updatedUser = dto.updatedUser
                    entityData.id = dto.id

                } else {
                    entityData.createdUser = dto.createdUser;
                }
                const data = await this.repo.save(entityData);
                res.push(new BankDetailsRequest(data.id,data.bankName,data.bankAccount,data.swiftCode,data.ifscCode,data.branchName,data.bankAddress,data.company,data.createdUser,data.updatedUser,data.isActive,data.versionFlag,data.createdAt))
                return new BankDetailsResponseModel(true, 1, isUpdate ? 'Data updated successfully' : 'Bank created successfully', res);
            } catch (err) {
                throw err;
            }
        }
        async activateOrDeactivate(request: BankDetailsRequest): Promise<BankDetailsResponseModel> {
            try {
                console.log(request,'serviceeeeeee');
                
                const bankExists = await this.repo.findOne(request.id);
                if (bankExists) {
                    if (request.versionFlag !== bankExists.versionFlag) {
                        throw new BankDetailsResponseModel(false,10113, 'Someone updated the current bank information.Refresh and try again');
                    } else {
                        
                            const bankStatus =  await this.repo.update(
                                { id: request.id },
                                { isActive: request.isActive,updatedUser: request.updatedUser });
                           
                            if (bankExists.isActive) {
                                if (bankStatus.affected) {
                                    const bankResponse: BankDetailsResponseModel = new BankDetailsResponseModel(true, 10115, 'Bank Account is de-activated successfully');
                                    return bankResponse;
                                } else {
                                    throw new BankDetailsResponseModel(false,10111, 'Bank Account is already deactivated');
                                    // await this.logService.createLog(1,'create', 'bank', savedbankDto.Bank AccountId, true, '');
    
                                }
                            } else {
                                if (bankStatus.affected) {
                                    const bankResponse: BankDetailsResponseModel = new BankDetailsResponseModel(true, 10114, 'Bank Account is activated successfully');
                                    return bankResponse;
                                } else {
                                    throw new BankDetailsResponseModel(false,10112, 'Bank Account is already  activated');
                                  //  await this.logService.createLog(1,'create', 'bank', savedCertificatesDto.certificateId, true, '');
    
                                }
                            }
                        // }
                    }
                } else {
                    throw new BankDetailsResponseModel(false,99998, 'No Records Found');
                }
            } catch (err) {
              return err;
            }
        }

    async getBankDetailsByCompany(req:CompanyReq):Promise<CommonResponse>{
        try{
            const getInfo = await this.repo.find({where:{company:req.company}})
            if(getInfo.length >0){
                return new CommonResponse(true,1,'Data retrieved',getInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }
    async getBankDetailsById(req:BankIdReq):Promise<CommonResponse>{
        try{
            const getInfo = await this.repo.findOne({where:{id:req.id}})
            if(getInfo){
                return new CommonResponse(true,1,'Data retrieved',getInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }
}